import React, { useState } from "react";
import { truncateHTML } from "../../../helpers/truncateHTML.ts";
import TranslationIndicator from "@/components/shared/TranslationIndicator.tsx";
import classNames from "classnames";

export default function TruncateableContent({
  content,
  truncateLength = 600,
  translated,
  showMoreButton = true,
  className,
}: {
  content?: string;
  truncateLength?: number;
  translated?: boolean;
  showMoreButton?: boolean;
  className?: string;
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const textContent = content?.replace(/<[^>]*>/g, "");
  const shouldTruncate = textContent && textContent.length > truncateLength;

  const displayContent =
    shouldTruncate && !isExpanded && content
      ? truncateHTML(content, { length: truncateLength })
      : content;

  const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };
  return (
    <>
      {displayContent && (
        <div
          className={className}
          dangerouslySetInnerHTML={{ __html: displayContent }}
        />
      )}
      {shouldTruncate && !isExpanded && showMoreButton && (
        <>
          {!window.isApp && <span>…</span>}
          <button
            className={classNames({
              "btn btn-light flex w-full justify-center text-xl h-11":
                window.isApp,
              "text-primary hover:underline": !window.isApp,
            })}
            type="button"
            onClick={handleToggle}
          >
            {I18n.t(
              window.isApp
                ? "js.activitystreams.mobile.more"
                : "js.activitystreams.more",
            )}
          </button>
        </>
      )}
      {translated && <TranslationIndicator />}
    </>
  );
}
